import { useEffect, useState } from "react";
import type { PhoneSize } from "../components/ui/phones/iphone";

export function usePhoneSize(): PhoneSize {
  const [size, setSize] = useState<PhoneSize>("md");

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width >= 1440) {
        setSize("xl");
      } else if (width >= 1150) {
        setSize("lg");
      } else if (width >= 1024) {
        setSize("md");
      } else {
        setSize("sm");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return size;
}
